import React, { useState, useEffect, useRef } from 'react';

// Custom hook for reliable interval timing
function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

const NameTypewriter = () => {
  // State
  const [text, setText] = useState('');
  const [wordIndex, setWordIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isRandomizing, setIsRandomizing] = useState(false);
  const [charIndex, setCharIndex] = useState(0);
  const [randomizeCount, setRandomizeCount] = useState(0);
  
  // Constants
  const finalName = "TOMER KATZ";
  const randomWords = ["HACKING", "ORCHESTRATING", "ANALYZING", "MAKING THINGS HAPPEN"];
  const allWords = [...randomWords, finalName];
  const glitchChars = "!@#$%^&*()_+-=[]{}|;:,.<>/?";
  
  // Helper functions
  const getRandomChar = () => glitchChars[Math.floor(Math.random() * glitchChars.length)];
  
  const randomizeAllChars = () => {
    if (text.length === 0) return '';
    
    return Array.from({ length: text.length })
      .map(() => getRandomChar())
      .join('');
  };
  
  // Typing/deleting interval logic
  useInterval(() => {
    // Get current word
    const currentWord = allWords[wordIndex];
    const isLastWord = wordIndex === allWords.length - 1;
    
    // Handle typing
    if (isTyping) {
      if (charIndex < currentWord.length) {
        setText(prev => prev + currentWord[charIndex]);
        setCharIndex(prev => prev + 1);
      } else {
        // Done typing
        setIsTyping(false);
        // For last word, just stay displayed
        if (isLastWord) return;
        // Otherwise, start randomizing before deletion
        setIsRandomizing(true);
        setRandomizeCount(0);
      }
      return;
    }
    
    // Handle randomizing (transition state)
    if (isRandomizing) {
      setText(randomizeAllChars());
      setRandomizeCount(prev => prev + 1);
      
      if (randomizeCount > 10) {
        setIsRandomizing(false);
        setIsDeleting(true);
      }
      return;
    }
    
    // Handle deleting
    if (isDeleting) {
      if (text.length > 0) {
        setText(randomizeAllChars().slice(0, -1));
      } else {
        // Done deleting
        setIsDeleting(false);
        setWordIndex(prev => prev + 1); // Move to next word
        setCharIndex(0); // Reset char index
        setIsTyping(true); // Start typing again
      }
    }
  }, isRandomizing ? 80 : 120); // Faster during randomization
  
  return (
    <div className="name-container" style={styles.nameContainer}>
      <div 
        id="typewriter" 
        className="neon-text" 
        style={styles.typewriter}
      >
        {text}
      </div>
    </div>
  );
};

const styles = {
  nameContainer: {
    margin: '3rem auto',
    perspective: '1000px',
    height: '6rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  typewriter: {
    fontSize: '4rem',
    fontWeight: 'bold',
    color: '#0ff',
    textShadow: '0 0 5px #0ff, 0 0 10px #0ff, 0 0 20px #0ff, 0 0 40px #0ff',
    letterSpacing: '5px',
    animation: 'flicker 2s infinite alternate',
    textAlign: 'center',
    minHeight: '4rem',
    minWidth: '200px',
    display: 'inline-block',
  }
};

export default NameTypewriter; 